import { mapState } from 'vuex'

export default {
  data: () => ({}),
  computed: {
    ...mapState('video', { video: 'video' }),
    ...mapState('user', {
      planInfo: 'userPlanInfo',
    }),
    updateAnalyticsTime() {
      return { time: 30, type: 'seconds' }
    },
  },
}
